import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { Switches } from '@occc-app/design-system';

import { TotalAvailableRollbackConfiguration } from './TotalAvailableRollbackConfiguration';

import { TAR_SWITCH_FIELD_NAME } from '../constants';

type TotalAvailableRollbackEligibleFormItemParams = {
  showTARConfigurationFields?: boolean;
};

export const TotalAvailableRollbackEligibleFormItem = ({
  showTARConfigurationFields,
}: TotalAvailableRollbackEligibleFormItemParams) => {
  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' flexDirection='column'>
          <Typography variant='h6'>Total Available Rollback eligible</Typography>
          <Typography variant='body2' color='textSecondary'>
            Allow a member to select this product group when setting their Total Available Rollback
            fuel grade.
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            Note: Member’s will see the name of this product group in Experience
          </Typography>
        </Box>
        <Switches name={TAR_SWITCH_FIELD_NAME} data={{}} />
      </Box>
      {showTARConfigurationFields && <TotalAvailableRollbackConfiguration />}
    </>
  );
};
